/* eslint-disable jsx-a11y/anchor-is-valid */
import moment from "moment";
import React, { useContext, useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import Modal from "react-modal";
import { useParams } from "react-router-dom";
import { ContestantsContext, ContestContext } from "../../../App";
import { getDetailImage, useContestantDetail } from "../../../store";
import { numberWithCommas } from "../../../utils/common";
import { getTimeNow, getTimeVote } from "../../../utils/time";
import Button from "../../UI/Button";
import VoteModal from "./modal/ComboVoteModal";
import PriceModal from "./modal/PriceModal";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    width: "60%",
    minWidth: "350px",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
  },
  overlay: {
    background: "rgba(0, 0, 0, 0.45)",
    zIndex: "1",
  },
};
const customStylesPriceModal = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    width: "60%",
    minWidth: "350px",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    maxWidth: "575px",
    background: "#FABCD8",
    border: "unset",
  },
  overlay: {
    background: "rgba(0, 0, 0, 0.45)",
    zIndex: "1",
  },
};

const customStylesVoteModal = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    width: "60%",
    minWidth: "350px",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    maxWidth: "650px",
    border: "unset",
    maxHeight: "800px",
  },
  overlay: {
    background: "rgba(0, 0, 0, 0.45)",
    zIndex: "1",
  },
};

const ContestantDetail = () => {
  const [payUrl, setPayUrl] = useState("");
  const [combo, setCombo] = useState(0);
  const [isOpen, setOpen] = useState(false);
  const [isOpenPrice, setOpenPrice] = useState(false);
  const [openMethod, setOpenMethod] = useState(false);

  const [comboVote, setComboVote] = useState([]);
  const [openComboVote, setOpenComboVote] = useState(false);

  const { missId } = useParams();
  const { contestant, getContestantDetail, getPayUrl } = useContestantDetail();

  const { contestants } = useContext(ContestantsContext);
  const contestantRank = contestants?.find(
    (item) => item.contestantId === contestant.id
  );

  const { contest } = useContext(ContestContext);
  const now = getTimeNow();

  const { start, end } = getTimeVote(contest);

  const isVoteTime = now >= start && now <= end;

  useEffect(() => {
    // getVoteList(missId, 1, 10);
    getContestantDetail(missId);
  }, [getContestantDetail, missId]);

  const onHandleVote = async (combo, gateway) => {
    try {
      // const res = await axios.get(`${fakeServer}/api/momo/${missId}/${combo}`);
      const res = await getPayUrl(gateway, missId, combo);
      setPayUrl(res.data.payUrl);
      setCombo(combo);
      setOpen(true);
    } catch (error) {
      console.log("error when get pay Url");

      setPayUrl("");
      setCombo(combo);
      setOpen(true);
    }
  };

  return (
    <div className="bs-row row-sm-15">
      <div className="bs-col md-50-15">
        <div className="detail-left">
          <img
            src={getDetailImage(contestant.code, contestant.info?.table)}
            alt=""
            style={{ width: "100%" }}
          />
          {/* <div className="slide-control">
            <div
              className="detail__btn next__btn"
              type="button"
              onClick={this.previous}
            />
            <div
              className="detail__btn prev__btn"
              type="button"
              onClick={this.next}
            />
          </div>

          <Slider
            ref={(c) => (this.slider = c)}
            {...DETAIL_IMG_SLIDE_SLICK}
            className="slide-detailImages"
          >
            <div className="slide-item">
              <div className="item">
                <div className="img">
                  <div className="ImagesFrame">
                    <div className="ImagesFrameCrop0">
                      <img src={getDetailImage(missId)} alt="" />
                    </div>
                  </div>
                </div>
              </div>
            </div>

          <div className="slide-item">
            <div className="item">
              <div className="img">
                <div className="ImagesFrame">
                  <div className="ImagesFrameCrop0">
                    <img src={getDetailImage(missId)} alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          </Slider> */}
        </div>
      </div>
      <div className="bs-col md-50-15">
        <div className="detail-right">
          <div className="slide-detail">
            <div className="slide-item">
              <div className="item">
                <div className="text">
                  <div className="text-index">
                    <p className="index__name">
                      {/* <span className="title">
                        <FormattedMessage id="name" />:{" "}
                      </span>&nbsp; */}
                      {contestant.fullname}
                    </p>
                    <div className="item-text">
                      <p className="index__desc">
                        <span className="title">
                          <FormattedMessage id="contestant.id" />:
                        </span>
                        &nbsp;{contestant.code}
                      </p>
                      {contestant?.properties?.length &&
                        contestant?.properties.map((item) => {
                          if (item.name === "birth") {
                            const date =
                              moment.now() -
                              moment.utc(item.value, "DD/MM/YYYY");

                            const age = Math.floor(
                              date / 60 / 60 / 24 / 365 / 1000
                            );

                            return (
                              <p className="index__desc" key={item.name}>
                                <span>Tuổi: </span>
                                {age}
                              </p>
                            );
                          }

                          return (
                            <p className="index__desc" key={item.name}>
                              <span>{item.name}: </span>
                              {item.value}
                            </p>
                          );
                        })}

                      {process.env.REACT_APP_EVENT_ID === "bv_hhhc2024b" &&
                        missId === "018" && (
                          <p className="index__desc">
                            <span>Ghi chú: </span>
                            HỦY HỒ SƠ THEO THÔNG BÁO: 01/TB-HHHCVN-TB-HHS
                          </p>
                        )}

                      <p className="index__desc">
                        <FormattedMessage id="votePoints" /> :{" "}
                        <span
                          style={{
                            fontSize: "28px",
                            color: "#EC7CA2",
                            fontWeight: "bold",
                          }}
                        >
                          {contestantRank &&
                            numberWithCommas(contestantRank?.totalPoint)}
                        </span>
                      </p>
                      {/* <p className="index__desc">
                        Điểm quy đổi :{" "}
                        <span className="title">{missInfo?.totalPoint}</span>
                        0.5
                      </p> */}
                    </div>
                  </div>
                  <div className="item-btn">
                    <Button
                      className="vote_dropdown open-modal"
                      onClick={() => setOpenPrice(true)}
                      outline
                    >
                      <span>Xem quy đổi bình chọn</span>
                    </Button>

                    {isVoteTime && (
                      <Button
                        className="btn-vote"
                        onClick={() => setOpenComboVote(!openComboVote)}
                        // style={{ margin: "0 auto 10px" }}
                        outline
                      >
                        <span>Bình chọn ngay</span>
                      </Button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="modal-container">
        <Modal
          isOpen={isOpenPrice}
          onRequestClose={() => setOpenPrice(false)}
          style={customStylesPriceModal}
          contentLabel="Quy đổi điểm bình chọn"
          ariaHideApp={false}
        >
          <PriceModal onClose={() => setOpenPrice(false)} />
        </Modal>
      </div>

      <Modal
        isOpen={openComboVote}
        onRequestClose={() => setOpenComboVote(false)}
        style={customStylesVoteModal}
        contentLabel="Lựa chọn gói bình chọn"
        ariaHideApp={false}
      >
        <VoteModal
          missDetail={contestant}
          getPayUrl={getPayUrl}
          comboVoteOrder={comboVote}
          setComboVote={setComboVote}
          onClose={() => setOpenComboVote(false)}
        />
      </Modal>
    </div>
  );
};
// }

export default ContestantDetail;
